<template>
  <div class="cmp-booking-tasks-task_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="search">
        <InputField
          :value="basicFilter.search"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '180px',
            minWidth: '180px',
            width: '180px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
      </div>
      <Dropdown
        :style="{ maxWidth: '125px', width: '125px !important' }"
        :options="taskStatusTV"
        :selected="taskStatusSelectedTV"
        :placeholder="$t('task_status')"
        borderbottom
        v-on:selectedChange="(e) => onDropdownChange('status', e)"
        :listHeight="taskStatusTV.length ? (taskStatusTV.length + 1) * 32.1 : 130"
        multiple
        allnone
      ></Dropdown>

      <Dropdown
        :style="{ maxWidth: '125px', width: '125px !important' }"
        :options="bookingStatusTV"
        :selected="bookingStatusSelectedTV"
        :placeholder="$t('booking_status')"
        borderbottom
        v-on:selectedChange="(e) => onDropdownChange('booking_status_ids', e)"
        :listHeight="bookingStatusTV.length ? (bookingStatusTV.length + 1) * 32.1 : 150"
        multiple
        allnone
      ></Dropdown>

      <Dropdown
        :style="{ maxWidth: '125px', width: '125px !important' }"
        :options="usersTV"
        :selected="usersTV.find(e => e.value == basicFilter.assigned_user_id)"
        :placeholder="$t('assigned_user')"
        borderbottom
        v-on:selectedChange="(e) => onDropdownChange('assigned_user_id', e)"
        :listHeight="usersTV.length ? Math.min(usersTV.length * 32.1, 550) : 130"        
        deselect
        :deselectLabel="$t('select_all')"
      ></Dropdown>

      <Dropdown
        :style="{ maxWidth: '125px', width: '125px !important' }"
        :options="usersTV"
        :selected="usersTV.find(e => e.value == basicFilter.sent_user_id)"
        :placeholder="$t('sent_user')"
        borderbottom
        v-on:selectedChange="(e) => onDropdownChange('sent_user_id', e)"
        :listHeight="usersTV.length ? Math.min(usersTV.length * 32.1, 550) : 130"
        deselect
      ></Dropdown>

      <DatePicker2
        id="start"
        :showLabel="false"
        :value="basicFilter.start"
        @input="({ name, value }) => onDropdownChange(name, {value})"
        lw="70px"
        cw="110px"
        :hoverStyle="1"
        :placeholder="'Start Date'"
      />
      <DatePicker2
        id="end"
        :showLabel="false"
        :value="basicFilter.end"
        @input="({ name, value }) => onDropdownChange(name, {value})"
        lw="70px"
        cw="110px"
        :hoverStyle="1"
        :placeholder="'End Date'"
      />
      <div class="right-container ut-colcen">
        <div class="ut-flex">
          <button class="dt-button v5 s8" @click="fetchList()" style="white-space: nowrap; ">
            {{ $t("Apply filter") }}
          </button>
        </div>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        id="booking-tasks-task_list"
        class="h1"
        :config="tableConfig"
        :items="list"
        :headers="headers"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:groupIitem="{ item }">
          <tr
            class="group_title"
            style="cursor: pointer"
            :key="item['group_title']"
            @click="onRowClicked(item.chappter_key)"
          >
            <th>
              {{ item.group_title }}
            </th>
          </tr>
        </template>

        <template v-slot:item="{ item, tdcon }">
          <tr @click="onRowClicked(item.chappter_key)">
            <td v-bind="tdcon('task')">
              <span>
                {{ item["task"] }}
              </span>
            </td>
            <td v-bind="tdcon('artist_name')">
              <span>
                {{ item["artist_name"] }}
              </span>
            </td>
            <td v-bind="tdcon('status')">
              <span>
                {{ item.status }}
              </span>
            </td>
            <td v-bind="tdcon('due_date')">
              <span>
                {{ item.due_date }}
              </span>
            </td>
            <td v-bind="tdcon('users')">
              <span>
                {{ item.users }}
              </span>
            </td>
            <td v-bind="tdcon('notes')">
              <span>
                {{ item.notes }}
              </span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                src="static/icons/delete.svg"
                @click.stop="(e) => onTaskDelete(item)"
                class="dt-icon v5 s2 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";

import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "../../../plugins/datatable";
import { bookingListCalendarDateTabRoute } from "../router/router";
import InfoCard from "../../../dt-plugins/info-card/info-card.vue";
import { groupBy } from "lodash";
import { BookingService } from "../services/booking-service";
import { createTV } from "../../../models/text-value.model";
import { subscribeSubject } from "../../../utility";
import { Subject } from "rxjs";

export default {
  components: {
    NTable,
    InfoCard,
  },
  data: function () {
    return {
      tasks: [],

      loadingFlag: false,
      basicFilter: { search: "", status: "", booking_status_ids: "", assigned_user_id: "", sent_user_id: "", start: "", end: "" },
      formData: {},
      searchSubject: new Subject(),
    };
  },
  mounted: function () {
    this.fetchList();
    this.fetchFilterFormData();

    subscribeSubject(this, this.searchSubject, term => {
      this.fetchList();
    });
  },
  computed: {
    ...mapGetters(storeNS, {
      loggedUserTasks: "loggedUserTasks",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    headers: function () {
      return [
        createTableHeader("task", { fw: 700, f: 0.5 }),
        createTableHeader("artist_name", { f: 0.3 }),
        createTableHeader("status", { f: 0.2 }),
        createTableHeader("due_date", { f: 0.2 }),
        createTableHeader("users", { f: 0.2 }),
        createTableHeader("notes", { f: 0.2 }),
        createTableHeader("options", { text: false, mw: 40 })
      ];
    },
    list() {
      const obj = groupBy(this.loggedUserTasks || [], "chappter_key");
      let task_list = [];
      if (Object.keys(obj).length > 0) {
        Object.keys(obj).forEach((value, index) => {
          let objectValues = Object.values(obj)[index];
          objectValues[0].new_group_title = 1;
          objectValues[0].group_title = objectValues[0].chapter_name;
          task_list.push(...objectValues);
        });
      }
      return task_list;
    },
    taskStatusTV: function () {
      return createTV(
        (this.formData?.task_statuses || []).map((r) => ({ text: r, value: r })),
        "text",
        "value"
      );
    },
    taskStatusSelectedTV() {
      const assignedUserArr = this.basicFilter?.status ? this.basicFilter.status.split(",") : [];
      return (
        this.taskStatusTV.filter((r) => assignedUserArr.includes("" + r.value)) || []
      );
    },
    usersTV: function () {
      return createTV(
        (this.formData?.users || []),
        "user_name",
        "user_id"
      );
    },
    bookingStatusTV() {
      return (this.formData?.booking_status || []).map((e) => ({
        text: e.booking_status_name,
        value: e.booking_status_id,
        color: `#${e.booking_status_colour}`,
      }));
    },
    bookingStatusSelectedTV() {
      const assignedUserArr = this.basicFilter?.booking_status_ids ? this.basicFilter.booking_status_ids.split(",") : [];
      return (
        this.bookingStatusTV.filter((r) => assignedUserArr.includes("" + r.value)) || []
      );
    }
  },
  watch: {},
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GET_LOGGED_USER_TASKS]: ActionTypes.GET_LOGGED_USER_TASKS,
      [ActionTypes.BDTaskList.DELETE.SINGLE]: ActionTypes.BDTaskList.DELETE.SINGLE,
    }),
    async fetchFilterFormData() {
      const res = await BookingService.fetchBookingTaskFilterFormData();
      this.formData = res.data;
    },
    async fetchList() {
      this.loadingFlag = true;
      await this[ActionTypes.GET_LOGGED_USER_TASKS](this.basicFilter);
      this.loadingFlag = false;
    },
    onRowClicked(calendar_date_id) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: { calendar_date_id, tab: "tasks" },
      });
    },
    onSearchInputKeyup(event) {
      this.basicFilter.search = event.target.value;
      this.searchSubject.next(this.basicFilter.search);
    },
    onDropdownChange: function (name, value) {
      let val = value.value;
      if (["status", "booking_status_ids"].includes(name)) {
        val = value.map((r) => r.value).join();
      }
      this.basicFilter[name] = val;
    },
    onTaskDelete(item) {
      this[ActionTypes.BDTaskList.DELETE.SINGLE](item);
    }
  },
};
</script>

<style lang="scss" scoped>
.dt-ntable {
  --ntable-height: calc(100vh - 135px);
}
</style>
